import React from "react";
import {RoomReservation} from "../../modification/model";

export function InventoryRender(props: RoomReservation) {
    return <>{props.quantity} x {props.accommodationType} {props.roomConfiguration}, {props.mealPlan}, {props.condition.name}</>;
}
